var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSs = function SvgSs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#078930",
    d: "M0 0h20v10H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M0 0h20v7H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v3H0z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DA121A",
    d: "M0 3.5h20v3H0z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0F47AF",
    d: "m0 0 8.66 5L0 10z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#FCDD09",
    d: "m1.287 5 2.894.94-1.789-2.462v3.044l1.79-2.462z"
  })));
};
export default SvgSs;